export default __webpack_public_path__ + "static/media/planned-downtime.7a3719c8.svg";